import Image1 from "../assets/Image1.jpg";
import Image2 from "../assets/Image2.jpg";
import Image3 from "../assets/Image3.jpg";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "Deepak Aacharya",
    description:
      "A dedicated developer who doesn't stop until the problem is solved. Their work ethic and commitment to clean code are truly impressive.",
  },
  {
    id: 2,
    image: Image2,
    title: "Suman Chalise",
    description:
      "Incredibly easy to collaborate with. They bring a positive energy to the team and have a rare knack for explaining complex technical issues simply.",
  },
  {
    id: 3,
    image: Image3,
    title: "Manish Thapaliya",
    description:
      "A true professional who balances speed with quality. Their friendly approach to code reviews and feedback makes them a massive asset to any sprint.",
  },
];
